import React from "react";
import { TextField } from "@material-ui/core";

function NTFSInputField({
  label,
  value,
  placeholder,
  actionType,
  errorKey,
  classes,
  dispatch,
  removeErrorByKey,
  isEditMode,
  error,
}) {
  return (
    <div className={classes.customPadding}>
      <div>
        {label}
        <span className={classes.customErrorIndication}>*</span>
      </div>

      <TextField
        required
        value={value}
        onChange={(event) => {
          dispatch({ type: actionType, payload: event.target.value });
          removeErrorByKey(errorKey);
        }}
        variant="outlined"
        fullWidth
        placeholder={placeholder}
      />

      {error && error[errorKey] ? (
        <div style={{ color: "red" }}>{error[errorKey]}</div>
      ) : null}
    </div>
  );
}

export default NTFSInputField;
